/**
 * Users Service - Irrigo Platform
 * Servicio para gestión de usuarios
 */

import { api, ApiResponse, PaginatedResponse, PaginationParams } from './api';
import type { 
  ApiUser, 
  CreateUserRequest, 
  UpdateUserRequest,
  UpdatePasswordRequest 
} from '@/types/api';

// ============================================================================
// USERS SERVICE
// ============================================================================

export interface UserFilters extends PaginationParams {
  search?: string;
  role?: 'superadmin' | 'company_admin';
  companyId?: string;
}

export const usersService = {
  /**
   * Listar usuarios
   */
  async getAll(params?: UserFilters): Promise<PaginatedResponse<ApiUser>> {
    return api.getPaginated<ApiUser>('/users', params);
  },

  /**
   * Obtener usuario por ID
   */
  async getById(id: string): Promise<ApiResponse<ApiUser>> {
    return api.get<ApiUser>(`/users/${id}`);
  },

  /**
   * Crear nuevo usuario
   */
  async create(data: CreateUserRequest): Promise<ApiResponse<ApiUser>> {
    return api.post<ApiUser>('/users', data);
  },

  /**
   * Actualizar usuario
   */
  async update(id: string, data: UpdateUserRequest): Promise<ApiResponse<ApiUser>> {
    return api.put<ApiUser>(`/users/${id}`, data);
  },

  /**
   * Cambiar contraseña de usuario
   */
  async updatePassword(id: string, data: UpdatePasswordRequest): Promise<ApiResponse<{ message: string }>> {
    return api.put<{ message: string }>(`/users/${id}/password`, data);
  },

  /**
   * Eliminar usuario
   */
  async delete(id: string): Promise<ApiResponse<{ message: string }>> {
    return api.delete<{ message: string }>(`/users/${id}`);
  },
};

export default usersService;
